import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Editor } from 'ngx-editor';
import { NgxSpinnerService } from 'ngx-spinner';
import { ParametrosConfiguracion } from '@models/base/identificadores.model';
import { ParametroSistemaDto } from '@models/parametros-sistema/parametroSistemaDto.model';
import { ParametroSistemaDescripcion } from '@models/parametros-sistema/parametrosSistemaDescipcion.model';
import { UpdateParametroSistemaRequest } from '@models/parametros-sistema/updateParametroSistemaRequest.model';
import { ParametroSistemaService } from '@services/parametroSistema/parametroSistema.service';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { CategoriaMenuItem } from '@services/configuracion/parametro-configuracion.service';
import { CommonModule } from '@angular/common';
import { DetalleCategoriaComponent } from '../detalle-categoria/detalle-categoria.component';
import { NavPanelConfiguracionComponent } from '../nav-panel-configuracion/nav-panel-configuracion.component';
import { AppRolesDirective } from '@directives/appRoles/app-roles.directive';
import { MatCardModule } from '@angular/material/card';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    DetalleCategoriaComponent,
    NavPanelConfiguracionComponent,
    AppRolesDirective,
    MatCardModule

  ],
  selector: 'app-configuracion',
  templateUrl: './configuracion.component.html',
  styleUrls: ['./configuracion.component.css'],
})
export class ConfiguracionComponent implements OnInit {
  categoriaSeleccionada: string | null = null;

  constructor(
  ) {
  }

  ngOnInit(): void {
  }
  onCategoriaSeleccionada(categoria: CategoriaMenuItem): void {
    this.categoriaSeleccionada = categoria.ruta;
  }

  ngOnDestroy(): void {
  }
  trackByItems(index: number, item: any): any {
    return item;
  }
}
